import { useState, useEffect, memo } from 'react'
import { buy_movie, rent_movie } from '../../../server/requests';
import close_modal from '../../trailerPlayers/modal_yt_player/images/close.png'
import { translateWord } from "../../Util/util";

export default memo(function PopUpPurchase({
    movie_info,
    setShow,
    watchList,
    setWatchList,
    title,
    callBackRentBuyMovie
}) {


    const btnRentMovie = (id) => {

        let body = { movie_id: movie_info.id, pricing_resolutions_id: id }
        rent_movie(body, res => {
            callBackRentBuyMovie()
        }, err => {
            console.log(err, 'err')
        })
    }

    const btnBuyMovie = (id) => {
        let body = { movie_id: movie_info.id, pricing_resolutions_id: id }

        buy_movie(body, res => {
            callBackRentBuyMovie()
        }, err => {
            console.log(err, 'err')
        })
    }

    const btnPurchaseByType = (id) => {

        if (title == 'Rent') btnRentMovie(id)

        else btnBuyMovie(id)

    }

    return (
        <>
            <div className="parentModal" onClick={() => setShow(false)}></div>
            <div className="MainModal purchase">
                <div className="container_modal">
                    <div className="close_modal">
                        <img src={close_modal} alt="" onClick={() => setShow(false)} />
                    </div>
                    <div className="title_modal purchase">
                        <h2>{translateWord(`${translateWord(title)}`)} <br /> “{movie_info.movie_translation && movie_info.movie_translation.name ? movie_info.movie_translation.name : movie_info.name}”</h2>
                    </div>
                    <div className={"types_group_purchase " + (title == "Buy" ? 'pad' : '')}>
                        {movie_info?.pricing?.pricing_resolutions?.map((item, index) => {
                            return (
                                <div className="type_purchase" key={index} onClick={() => btnPurchaseByType(item.id)}>
                                    <p>{title} {item.name} {item.price} {item.currency == "USD" ? '$' : item.currency}</p>
                                </div>
                            )
                        })}
                    </div>
                    {title == 'Rent' ?
                        <p className='desc_rent'>{translateWord('Rentals include 30 days to start watching this video and 48 hours to finish once started')}</p>
                        : null}
                </div>
            </div>
        </>
    )

}) 